import {
    EditRowDecorator, PrintableEvent, Switch, TableRow, TableRowDisplayEvent, TableRowMode, Textbox
} from "@mcleod/components";
import { Carrier } from "@mcleod/dispatch";
import { Comments } from "./Comments";
import { AutogenLayoutTableComment } from "./autogen/AutogenLayoutTableComment";

export class TableComment extends AutogenLayoutTableComment {
    private _displayCopyOrderFields: boolean = true;
    private _displayDispatchField: boolean = true;

    override onLoad(): void {
        this.tableComments.onEditLayoutLoaded = (rowDecorator: EditRowDecorator, tableRow: TableRow) => {
            const comments = rowDecorator.layout as Comments;
            comments.panelOrderFields.visible = this._displayCopyOrderFields;
            comments.textboxOrderCommentType.required = this._displayCopyOrderFields && "Y" === tableRow.data?.get("copy_to_order");
            comments.switchDispatch.visible = this._displayDispatchField;
        };

        if (!(this.owner instanceof Carrier)) {
            this.displayDispatchField = false;
        } else {
            this.displayCopyOrderFields = false;
        }
    }


    public set displayDispatchField(value: boolean) {
        if (value != this._displayDispatchField)
            this._displayDispatchField = value;
        this.syncColumns();
    }

    public set displayCopyOrderFields(value: boolean) {
        if (value != this._displayCopyOrderFields)
            this._displayCopyOrderFields = value;
        this.syncColumns();
    }

    syncColumns() {
        const columnOrderCommentType = this.tableComments.columns.find(c => c.headingCell.id === "columnOrderCommentType");
        this.tableComments.setColumnVisibility(columnOrderCommentType, this._displayCopyOrderFields);
        const columnCopyToOrder = this.tableComments.columns.find(c => c.headingCell.id === "columnHeaderCopyToOrder");
        this.tableComments.setColumnVisibility(columnCopyToOrder, this._displayCopyOrderFields);
        const displayAtDispatch = this.tableComments.columns.find(c => c.headingCell.id === "columnHeaderAssignDispatch");
        this.tableComments.setColumnVisibility(displayAtDispatch, this._displayDispatchField);
    }

    switchCopyToOrderOnChange(event) {
        if (event.userInitiatedChange) {
            const switchCopyToOrder = event.target as Switch;
            const row: TableRow = TableRow.getContainingTableRow(switchCopyToOrder);
            const textboxOrderCommentType = row.findComponentById("textboxOrderCommentType") as Textbox;
            if (textboxOrderCommentType != null)
                textboxOrderCommentType.required = switchCopyToOrder.checked;
        }
    }

    tableCommentsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.target as TableRow;
        if (TableRowMode.QUICK_ADD === tableRow.mode) {
            const labelDate = tableRow.findComponentById("labelDate");
            if (labelDate != null) {
                labelDate.visible = false;
            }
            const textboxEnteredUserId = tableRow.findComponentById("textboxEnteredUserId") as Textbox;
            if (textboxEnteredUserId != null) {
                textboxEnteredUserId.visible = false;
            }
        }
    }

    commentTypeBeforeLookup(event) {
        event.filter.is_active = "Y";
    }

    textboxEnteredUserIdOnPrintable(event: PrintableEvent) {
        const textbox = event.target as Textbox;
        textbox.printable = true;
    }
}
